module.exports = __webpack_public_path__ + "static/media/maxbountyreferral-300x250.ee249cf9.jpg";